export default __webpack_public_path__ + "static/media/ambient-bright-purple-blue.b4ac4138.jpg";